"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftTagSelect_styles_1 = require("./LftTagSelect.styles");
var LftTagSelect = function (_a) {
    var _b, _c;
    var ariaLabel = _a.ariaLabel, bgColor = _a.bgColor, children = _a.children, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, disabled = _a.disabled, id = _a.id, label = _a.label, _d = _a.selected, selected = _d === void 0 ? false : _d, lftClick = _a.lftClick;
    var _e = (0, react_1.useState)(selected), isSelected = _e[0], setIsSelected = _e[1];
    var tagLabel = typeof children === 'string' ? children : label;
    var _handleClick = function (e) {
        setIsSelected(!isSelected);
        lftClick && lftClick(e);
    };
    (0, react_1.useEffect)(function () {
        setIsSelected(selected);
    }, [selected]);
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' &&
                (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf('localhost')) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf('dev')) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "check_" + dataElement;
        }
    }
    return ((0, jsx_runtime_1.jsx)(LftTagSelect_styles_1.TagSelectStyled, __assign({ "aria-disabled": disabled, "aria-label": (selected ? "Selecionado " : "Não selecionado ") + (ariaLabel ? ariaLabel : tagLabel) + (selected ? " Pressione Enter para alterar" : " Pressione Enter para selecionar"), bgColor: bgColor, className: isSelected ? 'selected' : '', "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-tagselect", "data-testid": dataTestId ? dataTestId : id && id, disabled: disabled, id: id, selected: isSelected, type: "button", onClick: _handleClick }, { children: tagLabel }), void 0));
};
exports.default = LftTagSelect;
